import request from '@/utils/request'

// 导出列表
export function apiScpExportSuppliesRemain (params) {
  return request({
    url: '/scp/scpMpsPlans/exportSuppliesRemain',
    method: 'get',
    params: params
  })
}
